export default [
    {
        path: '/maintenance',
        name: 'MaintenanceMode',
        component: () =>
            import(/* webpackChunkName: "MaintenanceMode" */ '@/views/MaintenanceMode/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/get-tax-down',
        name: 'GetTaxDown',
        component: () => import(/* webpackChunkName: "GetTaxDown" */ '@/views/GetTaxDown/index.vue')
    },
    {
        path: '/get-cobas-plus',
        name: 'GetCobasPlus',
        component: () =>
            import(/* webpackChunkName: "GetCobasPlus" */ '@/views/GetCobasPlus/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/know-cobas-plus',
        name: 'KnowCobasPlus',
        component: () =>
            import(/* webpackChunkName: "KnowCobasPlus" */ '@/views/KnowCobasPlus/index.vue')
    },
    {
        path: '/activation-cobas-plus',
        name: 'ActivationCobasPlus',
        component: () =>
            import(
                /* webpackChunkName: "ActivationCobasPlus" */ '@/views/ActivationCobasPlus/index.vue'
            )
    },
    {
        path: '/ciber-security',
        name: 'cibersecurity',
        component: () =>
            import(/* webpackChunkName: "CiberSecurity" */ '@/views/CiberSecurity/index.vue')
    },
    {
        path: '*',
        redirect: { name: 'Position' }
    }
];
